import { serviceProvider } from "./serviceProvider";

const headerData=[];
/**
 * all api services of login user
 */
 const loginServices={
    validateUserLogin
}

/**
 * 
 * @param {function for validate user login by passing payload of login and password} reqPayload 
 * @returns 
 */
async function validateUserLogin(reqPayload) {
    return await serviceProvider("POST","Login/ValidateUser",reqPayload,headerData)
}

  export default loginServices;